import React from 'react';
import { Text } from '@user-portal/wikr-components';
import { useTranslation } from 'react-i18next';

import * as S from './styled';

export const IncludedInYourPlanRow = ({ isCardRow = false }) => {
  const { t } = useTranslation();

  return (
    <S.ListContainer $paddingTop={8} $isCardRow={isCardRow}>
      <Text
        type={isCardRow ? 'medium-text' : 'caption'}
        color={isCardRow ? 'text-main' : 'text-secondary-subdued'}
        mb={8}
      >
        {t('subscription.includedInYourPlan')}
      </Text>
      <S.List isCardRow={isCardRow}>
        <li>
          <Text
            type={isCardRow ? 'medium-text' : 'caption'}
            color={isCardRow ? 'text-main' : 'text-secondary-subdued'}
            mb={8}
          >
            {t('subscription.personalizedProgram')}
          </Text>
        </li>
        <li>
          <Text type={isCardRow ? 'medium-text' : 'caption'} color={isCardRow ? 'text-main' : 'text-secondary-subdued'}>
            {t('subscription.premiumContent')}
          </Text>
        </li>
      </S.List>
    </S.ListContainer>
  );
};
